/**
 * SandTile - Disappears when stepped on
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export class SandTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `sand-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.SAND;
  }

  textureDescriptor(): TextureDescriptor {
    return { type: "png", path: "tiles/sand.png" };
  }

  clone(): SandTile {
    const copy = new SandTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "sand", id: this.id, col: this.col, row: this.row };
  }
}
